import { render, staticRenderFns } from "./sfc-blue-box.vue?vue&type=template&id=41eaaee9&scoped=true&lang=pug&"
import script from "./sfc-blue-box.vue?vue&type=script&lang=js&"
export * from "./sfc-blue-box.vue?vue&type=script&lang=js&"
import style0 from "./sfc-blue-box.vue?vue&type=style&index=0&id=41eaaee9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eaaee9",
  null
  
)

export default component.exports